import { learningApi } from 'services/api'

export const SEND_EMAIL_FORGOT_PASSWORD = async (email: string) => {
  try {
    const result = await learningApi.patch('/student/auth/password/forgot', {
      email,
    })

    return result
  } catch (err) {
    console.log(err)
    throw err
  }
}
